module.exports = new __parcel__URL__("brand-strand-bottom.605820f5.png").toString();